import SearchMatches from './SearchMatches'

export default SearchMatches
